import * as React from "react";
import iconDefaultLogo from "../../assets/images/live-logo-big.png";
import "./style/index.scss";
import { observer, inject } from "mobx-react";
interface IProps {
  store?: any;
}
@inject("store")
@observer
export default class HeaderComponent extends React.Component<IProps, any> {
  public render() {
    const { liveInfo, liveTime } = this.props.store;
    const { logo, title, customLogo } = liveInfo;
    let sLogo: string;
    if (!logo && !customLogo) {
      sLogo = iconDefaultLogo;
    } else if (!!logo) {
      sLogo = `https://cdn.xylink.com/${logo}`;
    } else {
      sLogo = customLogo;
    }

    return (
      <div className="header-container">
        <div className="header-left">
          <div className="header-logo">
            <img src={sLogo} alt="" />
          </div>

          <div className="header-info">
            <h1>{title}</h1>
            <p>直播开始时间: {liveTime}</p>
          </div>
        </div>

        {!liveInfo.customLogo && (
          <div className="header-right">
            <a className="btn-style btn-a-link" href="https://www.xylink.com">
              了解小鱼易连
            </a>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pc/component/header/index.tsx